<!--
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-10-22 16:27:04
 * @LastEditors: zhongbin.chen
 * @LastEditTime: 2021-12-15 21:07:07
-->
<template>
  <div class="rolesclass">
    <div class="contentWrapper disinfectList">
      <div class="rolestop">
        <span>{{$t('role.rolelist')}}</span>
        <!-- <el-icon>
    <Plus />
  </el-icon> -->
        <!-- <el-button type="primary">
      <el-icon class="el-icon--right" :color="color"><Plus /></el-icon> 添加角色
    </el-button> -->
        <span class="btnadd" @click="addroles" :style="{width:getLanguage()!='en'?'':'122px'}">
          <el-icon size="16" class="addroles">
            <Plus />
          </el-icon>
          <span>{{$t('role.addroles')}}</span>
        </span>
      </div>
      <!-- <el-table
        :data="tableData"
        @row-click="goTaskInfo"
        :row-class-name="tableRowClassName"
        style="width: 100%"
      > -->
      <!-- :row-class-name="tableRowClassName"先关闭 -->
      <el-table :data="tableData" style="width: 100%" header-row-class-name="Headerrowclass">
        <!-- <el-table-column prop="sn" :label="'序号'" /> -->
        <!-- <el-table-column prop="room_name" :label="'开始时间'" /> -->
        <!-- <el-table-column
          prop="disinfect_type"
          :label="'结束时间'"
        >
          <template #default="{ row }">{{
            disinfectType(row.disinfect_type)
          }}</template>
        </el-table-column> -->
        <el-table-column prop="name" :label="$t('role.names')" width="180">
          <template #default="{ row }">
            <span>{{ row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="menu" :label="$t('route.jurisdiction')">
          <template #default="{ row }">{{ getmenulist(row.menu) }}</template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('account.remark')">
          <template #default="{ row }">
            <span>{{ row.remark?row.remark:'-' }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="status" :label="'状态'">
          <template #default="{ row }">
             <el-popover effect="light" trigger="hover" placement="top" width="auto">
            <span
              class="circular"
              :style="{ background: filterStatus(row.status, 1) }"
            />
            <span class="circular_t">{{ filterStatus(row.status, 2) }}</span>
             </el-popover>
          </template>
          <template #reference>
            <el-tag>{{ row.status }}</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column :label="$t('account.operation')">
          <template #default="{ row }">
            <div>
              <span :style="{ color: '#1890FF' }" @click="editroleas(row)"
                >{{$t('account.compile')}}</span
              ><span
                :style="{ marginLeft: '32px', color: '#F5222D' }"
                @click="deleteroleas(row)"
                >{{$t('account.delete')}}</span
              >
            </div>
          </template>
        </el-table-column>
        <template #empty>
          <div>
            <!-- <img :src="totalImg.nodata" /> -->
            <p>{{ $t("system.noData") }}</p>
          </div>
        </template>
      </el-table>
      <el-pagination
        background
        v-show="total > 0"
        :page-size="formInline.pageSize"
        :total="total"
        :current-page="page"
        :page-sizes="[10, 20, 50]"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, prev, pager, next, sizes"
        class="pagination"
      />
    </div>
    <el-dialog
      v-model="dialogVisible"
      :title="dialogtext"
      width="30%"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      v-if="dialogVisible"
    >
      <!-- <span>This is a message</span> -->
      <el-form :rules="rules" label-width="140px" :model="form" ref="userFormRef">
          <el-form-item :label="`${$t('role.names')}：`" prop="rolesname">
            <!--  :disabled="rolenamedisabled" 放出可以编辑角色名 -->
            <el-input
              type="text"
              :placeholder="$t('role.Entername')"
              maxlength="20"
              :style="{ width: '70%' }"
              v-model="form.rolesname"
              @change="rolesnameChange"
              @input="rolesnameInput"
            />
          </el-form-item>
          <el-form-item :label="`${$t('route.jurisdiction')}：`" prop="selectRules">
            <el-select
              v-model="form.valueroles"
              multiple
              collapse-tags
              style="width: 70%"
              @change="roleschanges"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.value == 'home'"
              />
            </el-select>
          </el-form-item>
           <el-form-item :label="`${$t('account.remark')}：`" prop="desc">
            <el-input
              v-model="fromdesc"
              type="textarea"
              :placeholder="$t('account.inputremarks')"
              :style="{ width: '70%' }"
              maxlength="100"
              @change="descChange"
              @input="descInput"
            />
          </el-form-item>
      </el-form>
      <div class="btndiv">
        <button class="btncancel" @click="cancelmsg">{{$t('universality.cancel')}}</button>
        <button class="btnconfirm" @click="trimbtn">{{$t('universality.confirm')}}</button
        >
        <!-- <el-form :model="form" :rules="rules" label-width="120px">
            <el-form-item
            :label="'名称：'"
            prop="selectRules"
          >
          <el-input type="text" :style="{width:'240px'}" v-model="form.region" />
          </el-form-item>
        </el-form> -->
      </div>
    </el-dialog>
    <Newdialog :dialogVisibles="deletemapflage" :detatildata="detatildata" :buttonColor="btnColor"
            :borderColor="dialogTtile" @setdata="delroles" @cancelvisibles="cancelvisibles"  />
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  reactive,
  watch,
  ref,
  nextTick,
  toRefs,
  unref,
} from "vue";
import { roomInfo } from "@/apis/region";
import { getRobotList } from "@/apis/user";
import { robotsSearch } from "@/apis/robot";
import { getroles, adddroles,deleteeroles, updateeroles} from "@/apis/roles";
import { useRouter, useRoute } from "vue-router";
import moment from "moment";
import { ElForm,ElMessage } from "element-plus";
import {getLanguage}from "@/utils/cookies"
import Newdialog from '@/components/tydialog/Dialog.vue'
import {
  getHM,
  totalImg,
  setRobotName,
  disinfectType,
  valueFilter,
} from "@/utils/robot";
import i18n from "@/locales/index";
const _t = i18n.global.t;
import { inputRules,inputLengthLimit } from '@/utils/validate'
export default {
  components: { Newdialog },
  setup() {
    const searchForm = ref(ElForm);
    const userFormRef = ref(ElForm)
    const router = useRouter();
    const route = useRoute();
     const validatePass = (rule, value, callback) => {
      if(state.isEdit) {
        if((value&&value.length>20) || (value&&value.length<6)) {
          callback(new Error(_t('user.passwordRule2')))
        } else if(value&&!rePassword.test(value)) {
          callback(new Error(_t('user.passwordRule2')))
        } else if (value&&newpassword.test(value)) {
          callback(new Error(_t('user.passwordRule2')))
        } else {
          callback()
        }
      } else {
        if ( value === '' ) {
          callback(new Error(_t('user.passwordRule1')))
        } else if(value.length>20 || value.length<6){
          callback(new Error(_t('user.passwordRule2')))
        } else if(!rePassword.test(value)) {
          callback(new Error(_t('user.passwordRule3')))
        } else if (value&&newpassword.test(value)) {
          callback(new Error(_t('user.passwordRule3')))
        } else {
          callback()
        }
      }
    };
    const validateUser = (rule, value, callback) => {
      if (value == '') {
        callback(new Error(_t('role.PleaseEntername')))
      } 
      // else if(value.length>20 || value.length<6){
      //   callback(new Error('请输入6-20位'))
      // }
      //  else if(!reName.test(value)) {
      //   callback(new Error(_t('user.donotcontain')))
      // } 
      else if (value.length>0) {
        callback()
      }
    };
    const state = reactive({
      deletemapflage: false,
      detatildata: {},
      btnColor: '#F5222D',
      color: "#ffffff",
      dialogTtile: '',
      params: {
        page: 1,
        pageSize: 1,
      },
      fromdesc: "",
      options: [
        {
          label: _t('route.home'),
          value: "home",
        },
        {
          label: _t('route.disinfect'),
          value: "disinfect",
        },
        {
          label: _t('route.building'),
          value: "building",
        },
        // {
        //   label: "IOT",
        //   value: "IOT",
        // },
        {
          label: _t('route.robot'),
          value: "robot",
        },
        {
          label: _t('route.jurisdiction'),
          value: "jurisdiction"
        },
        // 暂时关闭IOT和配送员
        // {
        //   label: _t('route.dispatcher'),
        //   value: "dispatcher"
        // }
        {
          label: _t('route.admage'),
          value: 'admage'
        }
      ],
      form: {
        rolesname:'',
        valueroles:[],
        id:''
      },
       rules: {
                // selectRules: [{ required: true}]
      rolesname: [
          {
            validator:validateUser,
            trigger: "blur",
            required:true
          },
        ],
            },
      rolenamedisabled: false,
      roomData: [],
      formInline: {
        pageSize: 10,
        page: 1,
        limit: true,
      },
      dialogVisible: false,
      totalImg: totalImg(),
      getHM: getHM,
      disinfectType: disinfectType,
      setRobotName: setRobotName,
      total: 0,
      page: 1,
      tableData: [],
      dialogtext:'',
      rolesnameChange(){
        state.form.rolesname = state.form.rolesname.trim()
      },
      rolesnameInput(){
        // state.form.rolesname = inputRules(state.form.rolesname)
        state.form.rolesname = inputLengthLimit(state.form.rolesname,20)
      },
      descChange(){
        state.fromdesc = state.fromdesc.trim()
      },
      descInput(){
        // state.fromdesc = inputRules(state.fromdesc)
        state.fromdesc = inputLengthLimit(state.fromdesc,100)
      },
      // 获取 角色列表
      getList() {
        const data = state.formInline;
        getroles(data).then((res) => {
          if (res.code == 200) {
            state.tableData = res.data.list;
            state.total = res.data.total;
            state.page = state.formInline.page;
        
          }
        });
      },
      // 获取权限列表 返回对应字符串
      getmenulist(rows) {
         let rowlist = rows.split(",");
         let msg = ''
         rowlist.map((ele,index)=>{
            if (ele == 'robot') {
                if (index+1==rowlist.length) {
                    msg+=_t('route.robot')
                } else {
                    msg+=_t('route.robot')+'/'
                }
            } else if (ele == 'building') {
              if (index+1==rowlist.length) {
                    msg+=_t('route.building')
                } else {
                    msg+=_t('route.building')+'/'
                }
            } else if (ele == 'disinfect') {
              if (index+1==rowlist.length) {
                    msg+=_t('route.disinfectTask')
                } else {
                    msg+=_t('route.disinfectTask')+'/'
                }
            } else if (ele == 'home') {
               if (index+1==rowlist.length) {
                    msg+=_t('route.home')
                } else {
                    msg+=_t('route.home')+'/'
                }
            } else if (ele == 'IOT') {
               if (index+1==rowlist.length) {
                    msg+='IOT'
                } else {
                    msg+='IOT/'
                }
            } else if (ele == 'jurisdiction') {
              if (index+1==rowlist.length) {
                    msg+=_t('route.jurisdiction')
                } else {
                    msg+=_t('route.jurisdiction')+'/'
                }
            } else if (ele == 'dispatcher') {
              if (index+1==rowlist.length) {
                    msg+= _t('route.dispatcher')
                } else {
                    msg+= _t('route.dispatcher') + '/'
                }
            } else if (ele == 'admage') {
                    if (index+1==rowlist.length) {
                    msg+= _t('route.admage')
                } else {
                   msg+= _t('route.admage') + '/'
                }
            }
         })
         return msg
      },
      handleSearch() {
        state.getList();
      
        // })
      },
      // 编辑
      editroleas(rows) {
    
        state.rolenamedisabled = true;
        state.form.valueroles = [];
  
        state.form.valueroles = rows.menu.split(",");
        state.fromdesc = rows.remark;
        state.form.rolesname = rows.name;
        state.form.id = rows.ID;
        state.dialogtext = _t('role.editroles')
        state.dialogVisible = true;
      },
      handleCurrentChange(page) {
        state.formInline.page = page;
        state.getList();
      },
      handleSizeChange(val) {
        state.formInline.pageSize = val;
        state.getList();
      },
      roleschanges(val) {
      
      },
      // 新增 用户
      addroles() {
        state.rolenamedisabled = false;
        state.form.valueroles = ['home'];
        state.fromdesc = "";
        state.form.rolesname = "";
        state.dialogtext = _t('role.addroles')
        state.dialogVisible = true;
      },
      cancelmsg() {
        state.dialogVisible = false;
        // state.rolenamedisabled = false;
        // state.valueroles = [];
        // state.fromdesc = "";
        // state.rolesname = "";
      },
      // 删除角色
      delroles() {
        // deleteeroles
         
          deleteeroles({
            name:state.detatildata.name
          }).then(res=>{
           
            if (res.code == 200) {
              state.deletemapflage = false
              state.getList()
            } else if (res.code == 10017) {
              ElMessage.error({
                center:'center',
                message: _t('role.TherolesDeletingfails')
              })
            } 
          })
      },
      cancelvisibles() {
         state.deletemapflage = false
      },
      deleteroleas (row) {
        state.detatildata = row
        state.detatildata['title'] = _t('role.deleteroles')
        state.detatildata['meassage'] = _t('role.Confirmdeletion')
        state.deletemapflage = true
      },
      trimbtn() {
        if (state.rolenamedisabled) {
          // true是编辑 false 是新增
          let params = {
            menu: state.form.valueroles.join(),
            name: state.form.rolesname,
            remark: state.fromdesc,
            id: state.form.id
          };
          let formflge = true
           unref(userFormRef).validate((valid) => {
           
            if (valid) {
            } else {
              formflge = false
            }
          })
          if (!formflge) return
          updateeroles(params).then(res=>{
           
           if (res.code == 200) {
            state.cancelmsg()
            state.getList()
            } else if(res.code == 70001) {
              ElMessage.error({
                center:'center',
                message:_t('role.nameAlreadyExists')
              })
            }
          })
        } else {
  
          // if (state.form.rolesname.length>20||state.form.rolesname.length<6) {
          //    return
          // }
          let formflge = true
           unref(userFormRef).validate((valid) => {
         
            if (valid) {
            } else {
              formflge = false
            }
          })
          if (!formflge) return
          let params = {
            menu: state.form.valueroles.join(),
            name: state.form.rolesname,
            remark: state.fromdesc
          };
          // 添加用户
          adddroles(params).then((res) => {
         
            if (res.code == 200) {
            state.cancelmsg()
            state.getList()
            } else if(res.code == 70001) {
              ElMessage.error({
                center:'center',
                message:_t('role.nameAlreadyExists')
              })
            }
          });
        }
      },
    });
    onMounted(() => {
      state.handleSearch();
    });
    return {
      ...toRefs(state),
      searchForm,
      userFormRef,
      moment,
      getLanguage
    };
  },
};
</script>
<style lang="scss">
.rolesclass{
 .select-box {
    display: flex;
    justify-content: center;
    position: relative;
    .tiptext{
        position: absolute;
        left: 0;
        top: 0;
    }
  }
}
.disinfectList {
  .el-range-editor--medium .el-range-separator {
    width: 25px;
  }
  .el-form-item {
    white-space: nowrap !important;
  }
  .el-form-item__label {
    width: 35% !important;
    display: inline-block;
  }
  .el-form-item__content {
    width: 80% !important;
    display: inline-block;
    .el-select,
    .el-cascader {
      width: 88% !important;
    }
  }
  .el-table__row {
    cursor: pointer;
  }
  .start_row td {
    background: #e7f7ff;
  }
  .demo-date-picker {
    display: flex;
    width: 100%;
    padding: 0;
    flex-wrap: wrap;
  }
  .demo-date-picker .block {
    padding: 30px 0;
    text-align: center;
    border-right: solid 1px var(--el-border-color);
    flex: 1;
  }
  .demo-date-picker .block:last-child {
    border-right: none;
  }
  .demo-date-picker .demonstration {
    display: block;
    color: var(--el-text-color-secondary);
    font-size: 14px;
    margin-bottom: 20px;
  }
}
</style>
<style lang="scss" scoped>
.disinfectList {
  position: relative;
  .Headerrowclass{
    // color: #000000;
  }
  h3 {
    margin: 0 0 16px;
  }
  .addroles {
    position: absolute;
    left: 10px;
    top: 8px;
  }
  .btnadd {
    position: relative;
    min-width: 102px;
    background: #1890ff;
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    padding: 0 20px 0 30px;
    margin-left: 20px;
    cursor: pointer;
  }
  .rolestop {
    display: flex;
    height: 32px;
    line-height: 32px;
    justify-content: space-between;
    align-items: center;
  }
  .robotItem {
    display: inline-block;
    position: relative;
    vertical-align: top;
    height: 230px;
    width: 90%;
    padding: 20px 20px 20px 130px !important;
    margin: 0 20px 30px;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    border-radius: 10px;
    font-size: 14px !important;
    cursor: pointer;

    .robotImg {
      position: absolute;
      height: 160px;
      top: 30px;
      left: 40px;
    }
    p {
      img {
        width: 24px;
        margin: -4px 4px 0 0;
      }
      span {
        display: inline-block;
        vertical-align: top;
      }
    }
  }
  .robotTitle {
    font-size: 18px;
    font-weight: bold;
  }
  .searchBtn {
    margin-left: 200px;
    .openText {
      margin-left: 24px;
      // color: #409eff;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .circular {
    position: relative;
    margin: 2px 6px;
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 6px;
    background: #000;
  }
}
.btndiv {
  margin: 44px 0 0 0;
  display: flex;
  justify-content: right;
  button {
    padding: 0 12px;
    height: 32px;
  }
  .btnconfirm {
    background: #1890ff;
    border-radius: 2px;
    border: none;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
  }
  .btncancel {
    cursor: pointer;
    background: #ffffff;
    margin-right: 16px;
    border-radius: 2px;
    border: 1px solid #d9d9d9;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
  }
}
</style>
